import React, { useState } from 'react';
import SearchSelect from '../../ui/components/SearchSelect'; // Adjust path if needed

function Test(): JSX.Element {
  const packageOptions = ['Alpha', 'Beta', 'Gamma', 'Delta', 'Epsilon'];
  const [selected, setSelected] = useState<string | null>(null);

  const handleSelect = (item: string) => {
    setSelected(item);
  };

  return (
    <div className="TestPageContainer">
      <h2>SearchSelect Test</h2>
      <SearchSelect
        items={packageOptions}
        onSelect={handleSelect}
        placeholder="Search packages..."
      />
      {selected && (
        <div className="SelectedDisplay">
          Selected: <strong>{selected}</strong>
        </div>
      )}
    </div>
  );
}

export default Test;
